/**
 * The tips slot of every chat prompt (docs/superpowers/specs/2026-10-20-page-skills-design.md §2.2).
 *
 * `analysisTips` is the method a master may edit on /admin/ai/skills; `pageRules` are the page's
 * data-reading rules, which live in code only. A saved card replaces the tips whole
 * (applyOverride) while the built-in profile keeps its page rules, so composing here, after the
 * override and on every call, means no saved row can freeze or drop them.
 *
 * The one composer: the chat (mediaChatService) and every test that reads a profile's tips use it.
 *
 * @module config/composedTips
 */
import type { AgentProfile } from './agentProfiles';

/** The editable tips, then a blank line and the page rules when there are any. */
export const composedTips = (profile: Pick<AgentProfile, 'analysisTips' | 'pageRules'>): string =>
  profile.pageRules ? `${profile.analysisTips}\n\n${profile.pageRules}` : profile.analysisTips;
